// extracted by mini-css-extract-plugin
module.exports = {"alipay":"alipay--1zKYq","bankCardTransfer":"bankCardTransfer--1ze7O","bankCard":"bankCard--3L7q6","label":"label--1cv7V"};